/**
 * chartView — remembers which metric and timeframe a ticker's chart is showing.
 *
 * 2026-09-12: the share picker needs to offer "this chart" meaning the view the
 * user is actually looking at, not a default. The chart owns that state
 * internally and is rendered deep inside a .map() over results, so threading it
 * up to the share button would mean lifting state through the whole row for a
 * cosmetic hint.
 *
 * This is a deliberately small module-level cache instead. It is a UI
 * convenience, never correctness: if nothing has registered a view yet, callers
 * fall back to the defaults below and the share still works.
 */
const DEFAULT_VIEW = { metric: 'revenue', range: '1y' };

const views = new Map();

export function setChartView(symbol, view) {
  const sym = (symbol || '').toUpperCase().trim();
  if (!sym || !view) return;
  views.set(sym, { metric: view.metric, range: view.range });
}

export function getChartView(symbol) {
  const sym = (symbol || '').toUpperCase().trim();
  return views.get(sym) || DEFAULT_VIEW;
}
